module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-valors-quality.0e3009c0.svg";